/**
 * Функция рендера таймлайна матча
 */
$.fn.matchTimeline = function() {
    const $self = $(this);
    const $timelineEvents = $self.find('.js-timeline-item');
    const $firstPeriodHolder = $self.find('.js-first-period');
    const $secondPeriodHolder = $self.find('.js-second-period');
    const $thirdPeriodHolder = $self.find('.js-third-period');
    const $overtimePeriodHolder = $self.find('.js-overtime-period');
    const $allEventsHolder = $self.find('.js-match-events-holder');

    const firstPeriodItems = [];
    const secondPeriodItems = [];
    const thirdPeriodItems = [];
    const overtimePeriodItems = [];

    /**
     * Объединяем события в один кластер, если они происходят в одну минуту
     * @param {Array} periodItems
     * @param {jQuery} $period
     */
    const clusterEventsItemsByMinute = (periodItems, $period) => {
        let clusterNumber = 1;

        let clusterStart = periodItems[0].data('time');

        periodItems.forEach(function (el) {
            if ((el.data('time') - clusterStart) <= 60) {
                el.attr('data-cluster', clusterNumber);
            } else {
                clusterNumber++;
                clusterStart = el.data('time');
                el.attr('data-cluster', clusterNumber);
            }
        });

        for (let i = 0; i < clusterNumber; i++) {
            $period.find('.js-period-events-holder')
                .append(`<div class="match-timeline__cluster js-timeline-cluster" data-cluster="${i + 1}"></div>`)
        }

        periodItems.forEach(function (el) {
            const clusterNumber = el.data('cluster');
            $period.find(`.js-timeline-cluster[data-cluster=${clusterNumber}]`)
                .append(el);
        });

        $period.find('.js-timeline-cluster').each(function () {
            const $firstItem = $(this).find('.js-timeline-item').first();
            const time = $firstItem.data('time');
            const period = $firstItem.data('period');
            $(this).attr('data-time', time);
            $(this).attr('data-period', period);
        });
    };

    /**
     * Сортируем события по периодам
     */
    const sortEventsItemsByPeriods = () => {
        $timelineEvents.each(function () {
            if ($(this).data('time') <= 1200) {
                firstPeriodItems.push($(this));
            }

            if ($(this).data('time') <= 2400 && $(this).data('time') > 1200) {
                secondPeriodItems.push($(this));
            }

            if ($(this).data('time') <= 3600 && $(this).data('time') > 2400) {
                thirdPeriodItems.push($(this));
            }

            if ($(this).data('time') > 3600) {
                overtimePeriodItems.push($(this));
            }
        });
    };

    /**
     * Наполняем период итемами событий
     * @param {jQuery} $period
     * @param {array} items
     * @param {string} periodName
     */
    const fillPeriodWithItems = ($period, items, periodName) => {
        items.forEach(function (el) {
            el.data('period', periodName);
            $period.find('.js-period-events-holder').append(el);
        })
    };

    /**
     * Распределяем события по периодам, удаляем пустой холдер событий
     */
    const fillPeriods = () => {
        if (firstPeriodItems.length && firstPeriodItems.length) {
            fillPeriodWithItems($firstPeriodHolder, firstPeriodItems, 'first');
            clusterEventsItemsByMinute(firstPeriodItems, $firstPeriodHolder);
        }

        if ($secondPeriodHolder.length && secondPeriodItems.length) {
            fillPeriodWithItems($secondPeriodHolder, secondPeriodItems, 'second');
            clusterEventsItemsByMinute(secondPeriodItems, $secondPeriodHolder);
        }

        if ($thirdPeriodHolder.length && thirdPeriodItems.length) {
            fillPeriodWithItems($thirdPeriodHolder, thirdPeriodItems, 'third');
            clusterEventsItemsByMinute(thirdPeriodItems, $thirdPeriodHolder);
        }

        if ($overtimePeriodHolder.length && overtimePeriodItems.length) {
            fillPeriodWithItems($overtimePeriodHolder, overtimePeriodItems, 'overtime');
            clusterEventsItemsByMinute(overtimePeriodItems, $overtimePeriodHolder);
        }

        $allEventsHolder.remove();
    };

    const getOverTimeLength = () => {
        const $overTimeItems = $(document).find('.js-overtime-period .js-timeline-cluster');
        let maxTime;
        let overTime;

        $overTimeItems.each(function (index, el) {
            const currentTime = $(el).data('time');
            if (index === 0) {
                maxTime = currentTime;
            } else {
                maxTime = (currentTime > maxTime) ? currentTime : maxTime;
            }
        });

        overTime = maxTime - 3600;
        overTime = (overTime < 1200) ? 1200 : overTime;

        return overTime;
    };

    /**
     * Расставляем итемы по таймлайну
     */
    const setEventsItemsPosition = () => {
        const $clusterItems = $(document).find('.js-timeline-cluster');
        $clusterItems.each(function () {
            const time = $(this).data('time');
            const period = $(this).data('period');
            const periodLength = 1200;

            if (period === 'first') {
                const leftPosition = time / (periodLength / 100);
                $(this).css('left', `${leftPosition}%`);
            }

            if (period === 'second') {
                const leftPosition = (time - 1200) / (periodLength / 100);
                $(this).css('left', `${leftPosition}%`);
            }

            if (period === 'third') {
                const leftPosition = (time - 2400) / (periodLength / 100);
                $(this).css('left', `${leftPosition}%`);
            }

            if (period === 'overtime') {
                const leftPosition = (time - 3600) / (getOverTimeLength() / 100);
                $(this).css('left', `${leftPosition}%`);
            }

        });
    };

    const initEvents = () => {

        $timelineEvents.on('click', function () {

            if (window.innerWidth < SVK.breakpoint['desktop-min']) {
                const $content = $(this).find('.timeline-bubble');
                const $container = $self.closest('.match-detailed-page__container');
                const containerLeft = $container.get(0).getBoundingClientRect().left;
                const containerRight = $container.get(0).getBoundingClientRect().right;
                const contentLeft = $content.offset().left - $content.outerWidth() / 2;
                const contentRight = $content.offset().left + $content.outerWidth() / 1.5;
                let delta = 0;

                if (contentRight > containerRight) {
                    delta = contentRight - containerRight;
                    const range = (-$content.width() / 2 - delta);
                    $content.css('transform', `translateX(${range}px)`);
                }
                if (contentLeft < containerLeft) {
                    delta = containerLeft - contentLeft;
                    $content.css('transform', 'translateX(' + (-$content.width() / 2 + delta) + 'px)');
                }
            }
        });
    }

    /**
     * Инициализация плагина
     */
    const init = () => {
        initEvents();
        sortEventsItemsByPeriods();
        fillPeriods();
        setEventsItemsPosition();
    };

    init();
};
